<template>
  <div class="publisher-brand-report">
    <breadcrumbs :breadcrumbsData="breadcrumbsData" #icon>
      <svg class="icon" aria-hidden="true" style="fill: #fff">
        <use xlink:href="#icon-shangpin"></use>
      </svg>
    </breadcrumbs>
    <!-- <noticeTool /> -->
    <a-spin :spinning="spinning">
      <div class="content-main" ref="mainRef">
        <div class="content-head">
          <div class="content-head-left">
            <artmisads-segmented-tabs
              v-model="activeTab"
              :items="programConfig"
            />
            <p>
              <span v-if="tagNumParams.lastUpdateAt">
                Last Update at:
                {{
                  moment(tagNumParams.lastUpdateAt).format('YYYY-MM-DD hh:mm')
                }}
              </span>
            </p>
          </div>
          <a-dropdown :getPopupContainer="() => mainRef">
            <template #overlay>
              <artmisads-dropdown-menu @click="handleExportClick">
                <a-menu-item key="all">Export All Data</a-menu-item>
                <a-menu-item key="filter">Export with Filters</a-menu-item>
              </artmisads-dropdown-menu>
            </template>
            <artmisads-button-special class="export-btn">
              <svg class="icon daochu" aria-hidden="true">
                <use xlink:href="#icon-daochu"></use>
              </svg>
              <span class="btn-text">Export</span>
              <svg class="icon artmisads-select-down-icon" aria-hidden="true">
                <use xlink:href="#icon-jiantou-xia-cu"></use>
              </svg>
            </artmisads-button-special>
          </a-dropdown>
        </div>
        <filterBar
          :params="params"
          :getList="getList"
          :setParams="setParams"
          platform="publisher"
          :dateParams="[
            params.startReportDateTimestamp,
            params.endReportDateTimestamp,
          ]"
        />
        <div class="tags">
          <filterTag
            :setParams="setParams"
            :tagNumParams="tagNumParams"
            :marketplace="params.marketplace"
            :defaultMetricName="defaultMetricName"
            :noNeedList="noNeedList"
          />
        </div>
        <div class="content">
          <p>
            {{ RESPORTS_TYPE_MAP[params.metricName]?.name }}
            <span v-if="showTop10">(Top 10)</span>
          </p>
          <div class="chart">
            <chart
              :showDate="false"
              :dataList="dataList"
              :width="chartWidth"
              showYName="brandName"
              showXName="metricValue"
              :lineColor="chartParams.lineColor"
              :isPercent="params.metricName === 'conversionsRate'"
              :lineBgOffsetTop="chartParams.lineBgOffsetTop"
              :lineBgOffsetZero="chartParams.lineBgOffsetZero"
              chartType="bar"
              :selectDaysNum="selectDaysNum"
              :showCurrent="false"
              defaultMetricName="detailPageViews"
              :startTimestamp="params.startReportDateTimestamp"
              :endTimestamp="params.endReportDateTimestamp"
              :onClickBarChart="onClickBarChart"
              :metricName="params.metricName"
            />
          </div>
          <div class="table">
            <tableContent
              :dataList="tableList"
              :marketplace="params.marketplace"
              :tableTotal="tableTotal"
              :params="tableParams"
              :activeTab="activeTab"
              :setParams="setTableParams"
              :onClickTableChart="onClickTableChart"
              :tagNumParams="tagNumParams"
              :onClickTableDetail="onClickTableDetail"
            />
          </div>
        </div>
      </div>
    </a-spin>
    <lineChartModal
      v-if="showlineChartModal"
      title="Brand Report"
      :activeTab="activeTab"
      :itemInfo="itemInfo"
      :onCancleModal="onCancleModal"
      pageType="publisherBrand"
      :defaultMetricName="params.metricName"
      :marketplace="params.marketplace"
      :noNeedList="noNeedList"
    />
    <trackingTableModal
      v-if="showTrackingTableModal"
      title="Brand Report"
      pageType="publisherBrandLink"
      :onCancleModal="onCancleModalTrackingTableModal"
      :dataList="trackingTableList"
      :tableTotal="trackingTableTotal"
      :params="trackingTableParams"
      :setParams="setTrackingTableParams"
      :loading="trackingTableModalLoading"
      :itemInfo="itemInfo"
    />
  </div>
</template>
<script setup>
import { computed, onMounted, ref, watch, onBeforeMount, nextTick } from 'vue'
import moment from 'moment'

import { publisherReportsApi } from '~/server/index'
import { RESPORTS_TYPE_MAP } from '~/contants/reports'
import breadcrumbs from '~/components/breadcrumbs.vue'
import filterBar from '~/components/reports/filterBar.vue'
import filterTag from '~/components/reports/filterTag.vue'
import lineChartModal from '~/components/reports/lineChartModal.vue'
import noticeTool from '~/components/reports/noticeTool.vue'
import chart from '~/components/reports/chart.vue'
import tableContent from './tableContent.vue'
import trackingTableModal from '~/components/reports/trackingTableModal.vue'
import { useSystemStore } from '@/storeData/system'
import { countBrandNames } from '~/utils'
const systemStore = useSystemStore()

const breadcrumbsData = {
  title: 'Brand Reports',
  color: '#4682FA',
  // hasTitleIcon:true,
  links: [
    {
      name: 'Home',
      path: '/publisher/dashboard',
    },
    {
      name: 'Reports',
      path: '/publisher/reports/performance',
    },
    {
      name: 'Brand',
      path: '/publisher/reports/brand',
    },
  ],
}
const needOpenBrandId = ref('')
const showTop10 = ref(false)
const showlineChartModal = ref(false)
const chartWidth = ref(1092)
const spinning = ref(false)

const dataList = ref([])
const params = ref({
  marketplace: 'amazon.com',
  startReportDateTimestamp: moment()
    .subtract(30, 'day')
    .startOf('day')
    .valueOf(),
  endReportDateTimestamp: moment().startOf('day').valueOf(),
  brandId: null,
  productId: null,
  metricName: 'detailPageViews',
  asin: null,
})

const itemInfo = ref()
const mainRef = ref()
const tableList = ref([])
const tableTotal = ref(0)
const tableParams = ref({
  page: 1,
  size: 200,
  sortDirection: 'desc',
  sortField: 'commissionAmount',
})

const tagNumParams = ref({
  totalClicks: null,
  totalDetailPageViews: null,
  totalAddToCart: null,
  totalConversions: null,
  totalOrders: null,
  totalConversionsRate: null,
  totalSalesAmount: null,
  totalDiscountedSalesAmount: null,
  totalBonusAmount: null,
  totalCommissionAmount: null,
  lastUpdateAt: null,
  totalFinalCommissionAmount: null,
})
const trackingTableModalLoading = ref(false)
const showTrackingTableModal = ref(false)
const trackingTableList = ref([])
const trackingTableTotal = ref(0)
const trackingTableParams = ref({
  page: 1,
  size: 10,
  marketplace: 'amazon.com',
  brandId: '',
  startReportDateTimestamp: moment()
    .subtract(30, 'day')
    .startOf('day')
    .valueOf(),
  endReportDateTimestamp: moment().startOf('day').valueOf(),
  sortDirection: 'desc',
  sortField: 'commissionAmount',
})
const setTrackingTableParams = (obj) => {
  const newObj = { ...trackingTableParams.value, ...obj }
  trackingTableParams.value = newObj
}
const onCancleModalTrackingTableModal = () => {
  showTrackingTableModal.value = false
}
const selectDaysNum = computed(() => {
  const { endReportDateTimestamp, startReportDateTimestamp } = params.value
  const intervalDays = moment(endReportDateTimestamp).diff(
    moment(startReportDateTimestamp),
    'days',
  )
  return intervalDays
})
const onClickTableDetail = (item) => {
  itemInfo.value = item
  // console.log(item,'item')
  setTrackingTableParams({
    brandId: item.brandId,
    startReportDateTimestamp: params.value.startReportDateTimestamp,
    endReportDateTimestamp: params.value.endReportDateTimestamp,
    marketplace: params.value.marketplace,
    page: 1,
    promotionType: 'brand',
  })
  showTrackingTableModal.value = true
}
const chartParams = computed(() => {
  let lineColor, lineBgOffsetTop, lineBgOffsetZero, chartParamsData, itemData
  itemData = RESPORTS_TYPE_MAP[params.value.metricName]
  lineColor = itemData.lineColor
  lineBgOffsetTop = itemData.lineBgOffsetTop
  lineBgOffsetZero = itemData.lineBgOffsetZero
  chartParamsData = { lineColor, lineBgOffsetTop, lineBgOffsetZero }
  return chartParamsData
})

const getChartWidth = () => {
  const $chart = document.querySelector('.chart')
  const widthNum = $chart.clientWidth - 20
  chartWidth.value = widthNum
}

const setTableParams = (obj) => {
  const newObj = { ...tableParams.value, ...obj }
  tableParams.value = newObj
}

const setParams = (obj) => {
  const newObj = { ...params.value, ...obj }
  setTableParams({ page: 1 })
  params.value = newObj
}

const activeTab = ref('0')
const programConfig = computed(() => {
  const src = systemStore.programConfig || []
  const tabs = src.map((item) => ({ ...item }))
  // 仅 Brand 页单独追加 Creator Connections
  if (!tabs.some((item) => item.key === '2')) {
    tabs.push({
      key: '2',
      label: 'Creator Connections',
      disabled: false,
    })
  }
  return tabs
})
const defaultMetricName = ref('detailPageViews')
const noNeedList = ref([
  'orders',
  'clicks',
  'acosAmount',
  'conversionsRate',
  'salesAmount',
  'bonusAmount',
  'commissionAndFeeAmount',
  'quantity',
  'finalCommissionAndFeeAmount',
  'finalCommissionAmount',
])
const isResetting = ref(false)

watch(
  params,
  async (newValue, oldValue) => {
    if (isResetting.value) {
      return
    }

    if (newValue.metricName !== oldValue.metricName) {
      switch (activeTab.value) {
        case '0':
          spinning.value = true
          await getList()
          spinning.value = false
          break
        case '1':
          spinning.value = true
          await getListAssociate()
          spinning.value = false
          break
        case '2':
          spinning.value = true
          await getListCc()
          spinning.value = false
          break
      }
    } else {
      switch (activeTab.value) {
        case '0':
          getAllData()
          break
        case '1':
          getAllDataAssociate()
          break
        case '2':
          getAllDataCc()
          break
      }
    }
  },
  { deep: true, flush: 'post' },
)

watch(
  tableParams,
  async (newValue, oldValue) => {
    if (isResetting.value) return
    const hasChanged = Object.keys(newValue).some(
      (key) => newValue[key] !== oldValue[key],
    )
    if (hasChanged) {
      switch (activeTab.value) {
        case '0':
          spinning.value = true
          await getTableList()
          spinning.value = false
          break
        case '1':
          spinning.value = true
          await getTableListAssociate()
          spinning.value = false
          break
        case '2':
          spinning.value = true
          await getTableListCc()
          spinning.value = false
          break
      }
    }
  },
  { deep: true, flush: 'post' },
)

watch(activeTab, async () => {
  await reserParams()
  await reserTableParams()
  switch (activeTab.value) {
    case '0':
      noNeedList.value = [
        'orders',
        'clicks',
        'acosAmount',
        'conversionsRate',
        'salesAmount',
        'bonusAmount',
        'commissionAndFeeAmount',
        'quantity',
        'finalCommissionAndFeeAmount',
        'finalCommissionAmount',
      ]
      defaultMetricName.value = 'detailPageViews'
      getAllData()
      break
    case '1':
      noNeedList.value = [
        'clicks',
        'detailPageViews',
        'addToCart',
        'conversions',
        'orders',
        'conversionsRate',
        'acosAmount',
        'discountedSalesAmount',
        'bonusAmount',
        'commissionAndFeeAmount',
        'finalCommissionAndFeeAmount',
      ]
      defaultMetricName.value = 'quantity'
      getAllDataAssociate()
      break
    case '2':
      noNeedList.value = [
        'detailPageViews',
        'addToCart',
        'conversions',
        'conversionsRate',
        'quantity',
        'acosAmount',
        'discountedSalesAmount',
        'commissionAndFeeAmount',
        'commissionAmount',
        'finalCommissionAndFeeAmount',
        'finalCommissionAmount',
      ]
      defaultMetricName.value = 'clicks'
      getAllDataCc()
      break
  }
})

const reserParams = async () => {
  isResetting.value = true
  nextTick(() => {
    params.value = {
      marketplace: 'amazon.com',
      startReportDateTimestamp: moment()
        .subtract(30, 'day')
        .startOf('day')
        .valueOf(),
      endReportDateTimestamp: moment().startOf('day').valueOf(),
      brandId: null,
      productId: null,
      metricName:
        activeTab.value === '0'
          ? 'detailPageViews'
          : activeTab.value === '1'
            ? 'quantity'
            : 'clicks',
      asin: null,
    }
    nextTick(() => {
      isResetting.value = false
    })
  })
}

const reserTableParams = async () => {
  isResetting.value = true
  nextTick(() => {
    tableParams.value = {
      page: 1,
      size: 200,
      sortDirection: 'desc',
      sortField: 'commissionAmount',
    }
    nextTick(() => {
      isResetting.value = false
    })
  })
}

const onClickBarChart = (clickData) => {
  // 从新的参数格式中获取数据
  const brandName = clickData.name || clickData // 兼容旧格式
  let item = clickData.itemData

  // 如果没有通过itemData获取到数据，使用原来的查找方式
  if (!item) {
    item = dataList.value.find((i) => i.brandName === brandName)
  }

  itemInfo.value = item
  itemInfo.value.startReportDateTimestamp =
    params.value.startReportDateTimestamp
  itemInfo.value.endReportDateTimestamp = params.value.endReportDateTimestamp
  showlineChartModal.value = true
}

const onClickTableChart = (item) => {
  itemInfo.value = item
  itemInfo.value.startReportDateTimestamp =
    params.value.startReportDateTimestamp
  itemInfo.value.endReportDateTimestamp = params.value.endReportDateTimestamp
  // console.log('itemInfo', itemInfo.value)
  showlineChartModal.value = true
}

const onCancleModal = () => {
  showlineChartModal.value = false
  itemInfo.value = undefined
}

const getList = async () => {
  let newparams = { ...params.value }
  const res =
    await publisherReportsApi.getPublisherCommissionReportsBrandMetric(
      newparams,
    )
  let { success, data } = res
  if (success) {
    if (data.length > 10) {
      data = data.splice(0, 10)
      showTop10.value = true
    }
    dataList.value =
      newparams.metricName === 'conversionsRate'
        ? data.map((item) => {
            return {
              ...item,
              metricValue: (item.metricValue * 100)
                .toFixed(2)
                .replace(/(\.\d*?[1-9])0+$|\.0+$/, '$1'),
            }
          })
        : data
  }
}

const getTableList = async () => {
  let newparams = { ...params.value, ...tableParams.value }
  if (needOpenBrandId.value) {
    newparams.sortField = 'discountedSalesAmount'
  }
  const res = await publisherReportsApi.getPublisherCommissionReportsBrand(
    newparams,
  )
  const { success, data } = res
  if (success) {
    tableList.value = data.data
    const brandNameCount = countBrandNames(data.data, 'brandName')

    // 为重复的amazonBrandName添加标识
    tableList.value = data.data.map((brand) => ({
      ...brand,
      hasDuplicate: brand.brandName && brandNameCount[brand.brandName] > 1,
    }))
    if (needOpenBrandId.value) {
      const needOpenBrandItem = data.data.find(
        (item) => item.brandId === Number(needOpenBrandId.value),
      )
      if (needOpenBrandItem) {
        onClickTableChart(needOpenBrandItem)
      }
      needOpenBrandId.value = null
    }
    tableTotal.value = data.total
  }
}
watch(trackingTableParams, async () => {
  getTrackingTableList()
})
const getTrackingTableList = async () => {
  trackingTableModalLoading.value = true
  trackingTableList.value = []
  trackingTableTotal.value = 0
  const res = await publisherReportsApi.getPublisherCommissionReportsTrackingId(
    trackingTableParams.value,
  )
  let { success, data } = res
  if (success) {
    trackingTableList.value = data.data.map((item, index) => {
      // 生成子项数据的辅助函数
      const createSubItem = (subItem, subIndex) => ({
        ...subItem,
        id: `${item.primaryTrackingId}_${index}_sub_${subIndex}`,
        primaryTrackingIds: subItem.subTrackingId
          ? undefined
          : subItem.primaryTrackingId,
      })

      // 判断是否需要创建子项
      const shouldCreateChildren = () => {
        const subList = item?.subTrackingIdList
        if (!subList?.length) return false

        if (subList.length > 1) return true
        if (subList.length === 1 && subList[0].subTrackingId) return true

        return false
      }

      return {
        ...item,
        id: item.primaryTrackingId,
        primaryTrackingIds: item.primaryTrackingId,
        children: shouldCreateChildren()
          ? item.subTrackingIdList.map(createSubItem)
          : undefined,
      }
    })
    trackingTableTotal.value = data.total
  }
  trackingTableModalLoading.value = false
}
const getPublisherCommissionReportsAgg = async () => {
  const res = await publisherReportsApi.getPublisherCommissionReportsAgg(
    params.value,
  )
  const { success, data } = res
  if (success) {
    tagNumParams.value = data
  }
}

const handleExportClick = async ({ key }) => {
  let exportParams = {
      endReportDateTimestamp: moment().startOf('day').valueOf(),
      marketplace: params.value.marketplace,
      startReportDateTimestamp: moment()
        .subtract(1825, 'day')
        .startOf('day')
        .valueOf(),
    },
    newExportParams = {}
  if (key === 'filter') {
    exportParams = { ...params.value }
  }
  for (let item in exportParams) {
    if (exportParams[item]) {
      newExportParams[item] = exportParams[item]
    }
  }
  const finalParams = {
    qs: newExportParams,
    fileName: `Brand-Reports-${moment().format('YYYY-MM-DD')}.csv`,
  }
  switch (activeTab.value) {
    case '0':
      finalParams.fileName = `Brand-Reports-Attribution-${moment().format(
        'YYYY-MM-DD',
      )}.csv`
      publisherReportsApi.exportCommissionBrandReports(finalParams)
      break
    case '1':
      finalParams.fileName = `Brand-Reports-Associate-${moment().format(
        'YYYY-MM-DD',
      )}.csv`
      publisherReportsApi.exportCommissionBrandReportsAssociate(finalParams)
      break
    case '2':
      finalParams.fileName = `Brand-Reports-CreatorConnections-${moment().format(
        'YYYY-MM-DD',
      )}.csv`
      publisherReportsApi.exportCommissionBrandReportsCc(finalParams)
      break
  }
}

const checkFromDashboard = () => {
  const artemisAds_dashboard_click_top_brand = localStorage.getItem(
    'artemisAds_dashboard_click_top_brand',
  )
  if (artemisAds_dashboard_click_top_brand) {
    needOpenBrandId.value = artemisAds_dashboard_click_top_brand
    localStorage.setItem('artemisAds_dashboard_click_top_brand', '')
  }
}

onBeforeMount(() => {
  checkFromDashboard()
})
const getAllData = async () => {
  spinning.value = true
  try {
    await Promise.all([
      getList(),
      getTableList(),
      getPublisherCommissionReportsAgg(),
    ])
  } catch (error) {
    console.error('请求执行失败:', error)
  } finally {
    spinning.value = false
  }
}
const getAllDataAssociate = async () => {
  spinning.value = true
  try {
    await Promise.all([
      getListAssociate(),
      getTableListAssociate(),
      getPublisherCommissionReportsAggAssociate(),
    ])
  } catch (error) {
    console.error('请求执行失败:', error)
  } finally {
    spinning.value = false
  }
}
onMounted(async () => {
  if (needOpenBrandId.value) {
    params.value.metricName = 'discountedSalesAmount'
    defaultMetricName.value = 'discountedSalesAmount'
  }
  getChartWidth()
  getAllData()
  window.addEventListener('resize', function () {
    getChartWidth()
  })
})

// Associate API functions
const getListAssociate = async () => {
  let newparams = { ...params.value }
  const res =
    await publisherReportsApi.getPublisherCommissionReportsBrandMetricAssociate(
      newparams,
    )
  let { success, data } = res
  if (success) {
    if (data.length > 10) {
      data = data.splice(0, 10)
      showTop10.value = true
    }
    dataList.value =
      newparams.metricName === 'conversionsRate'
        ? data.map((item) => {
            return {
              ...item,
              metricValue: (item.metricValue * 100)
                .toFixed(2)
                .replace(/(\.\d*?[1-9])0+$|\.0+$/, '$1'),
            }
          })
        : data
  }
}

const getTableListAssociate = async () => {
  let newparams = { ...params.value, ...tableParams.value }
  const res =
    await publisherReportsApi.getPublisherCommissionReportsBrandAssociate(
      newparams,
    )
  const { success, data } = res
  if (success) {
    tableList.value = data.data
    tableTotal.value = data.total
  }
}

const getPublisherCommissionReportsAggAssociate = async () => {
  const res =
    await publisherReportsApi.getPublisherCommissionReportsAggAssociate(
      params.value,
    )
  const { success, data } = res
  if (success) {
    tagNumParams.value = data
  }
}

const getListCc = async () => {
  const newparams = { ...params.value }
  const res =
    await publisherReportsApi.getPublisherCommissionReportsBrandMetricCc(
      newparams,
    )
  let { success, data } = res
  if (success) {
    showTop10.value = data.length > 10
    if (data.length > 10) {
      data = data.splice(0, 10)
    }
    dataList.value = data
  }
}

const getTableListCc = async () => {
  const newparams = { ...params.value, ...tableParams.value }
  const res = await publisherReportsApi.getPublisherCommissionReportsBrandCc(
    newparams,
  )
  const { success, data } = res
  if (success) {
    tableList.value = data.data
    tableTotal.value = data.total
  }
}

const getPublisherCommissionReportsAggCc = async () => {
  const res = await publisherReportsApi.getPublisherCommissionReportsAggCc(
    params.value,
  )
  const { success, data } = res
  if (success) {
    tagNumParams.value = {
      ...data,
      totalOrders: data.totalOrders ?? data.totalConversions ?? 0,
      totalClicks: data.totalClicks ?? 0,
    }
  }
}

const getAllDataCc = async () => {
  spinning.value = true
  try {
    await Promise.all([
      getListCc(),
      getTableListCc(),
      getPublisherCommissionReportsAggCc(),
    ])
  } catch (error) {
    console.error('请求执行失败:', error)
  } finally {
    spinning.value = false
  }
}
</script>
<style lang="less" scoped>
.publisher-brand-report {
  .content-main {
    border-radius: 12px;
    overflow: hidden;
    border-radius: 12px;
    background-color: var(--color-white);
    box-shadow: var(--section-box-shadow-6);
    .tags {
      padding: 20px 12px;
    }
    .content-head {
      display: flex;
      justify-content: space-between;
      height: 64px;
      padding-left: 16px;
      padding-right: 16px;
      .content-head-left {
        display: flex;
        align-items: center;
        > p {
          font-size: 14px;
          color: var(--dark-2);
          line-height: 19px;
          align-self: center;
          margin-left: 20px;
        }
      }

      > button {
        align-self: center;
        cursor: pointer;
        display: flex;
        .jiantou {
          width: 16px;
          height: 16px;
          fill: var(--dark-3);
          margin-left: 8px;
        }
        .daochu {
          width: 20px;
          height: 20px;
          margin-right: 8px;
          fill: var(--dark-1);
        }
        > svg {
          align-self: center;
        }
        > span {
          align-self: center;
        }
        .btn-text {
          align-self: center;
          font-weight: 500;
          line-height: 20px;
          margin-right: 8px;
        }
      }
    }
  }
  .content {
    padding: 16px;

    .table {
      margin-top: 40px;
    }
    .chart {
      padding: 0 10px;
    }
    > p {
      font-weight: 600;
      font-size: 20px;
      color: var(--dark-1);
      letter-spacing: 0.5px;
      line-height: 28px;
      margin-bottom: 30px;
      > span {
        color: var(--red-text);
        font-size: 16px;
        margin-left: 10px;
        line-height: 28px;
      }
    }
  }
}
</style>
